/** Zero-width and formatting characters that draw nothing and never carry
 *  meaning in a sheet cell: the soft hyphen, zero-width space, the byte order
 *  mark, the word joiner and invisible operators (U+2060-2064), and the
 *  bidirectional embedding (U+202A-202E) and isolate (U+2066-2069) controls.
 *  Mirrors the backend's common.StripInvisibleChars
 *  (internal/common/invisible_chars.go); keep the ranges in step. */
const INVISIBLE_CHARS = /[\u00AD\u200B\u202A-\u202E\u2060-\u2064\u2066-\u2069\uFEFF]/g;

/** The zero-width non-joiner and joiner and the left/right marks
 *  (U+200C-200F). Real text needs them (Persian ZWNJ, Indic half-forms and
 *  chillus, emoji sequences), so they are removed only from a cell that cannot
 *  be a name: a handle or link, a number, a column header. Mirrors the
 *  backend's StripAllInvisibleChars. */
const JOINER_MARKS = /[\u200C-\u200F]/g;

/** Removes the invisible characters that are never part of text. Safe for every
 *  cell, names included. */
export function stripInvisibleChars(text: string): string {
  return text.replace(INVISIBLE_CHARS, '');
}

/** stripInvisibleChars plus the joiners and direction marks: for a handle or
 *  link, a number or price, a column header. */
export function stripAllInvisibleChars(text: string): string {
  return stripInvisibleChars(text).replace(JOINER_MARKS, '');
}

/** Whitespace the way Go's strings.TrimSpace sees it: JS's `\s` plus U+0085
 *  (next line), which `String.prototype.trim` leaves in place. */
const EDGE_SPACE = /^[\s\u0085]+|[\s\u0085]+$/g;

export function trimSpace(text: string): string {
  return text.replace(EDGE_SPACE, '');
}
